// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import {
  browserLocalPersistence,
  getAuth,
  setPersistence,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
  apiKey: 'AIzaSyDZtaXjZD9ySmj8oj4J5sYjbSrWmAqUHeI',
  authDomain: 'image-submission-system.firebaseapp.com',
  projectId: 'image-submission-system',
  storageBucket: 'image-submission-system.appspot.com',
  messagingSenderId: '2914420345',
  appId: '1:2914420345:web:d8840a0c975c3cfe9876a8',
  measurementId: 'G-YYX3PK5V5V',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Set user sessions to persist in browser
setPersistence(auth, browserLocalPersistence);

export { auth, db, storage, functions };
